import { render, staticRenderFns } from "./dropOffBillDetail.vue?vue&type=template&id=19bb5743&scoped=true"
import script from "./dropOffBillDetail.vue?vue&type=script&lang=js"
export * from "./dropOffBillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb5743",
  null
  
)

export default component.exports